(function(){
  function scrollToForm(){
    var el=document.getElementById('harpah-wholesale-application');
    if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-hw-apply]');
    if(!a) return;
    var href=a.getAttribute('href');
    if(href==='#harpah-wholesale-application'){
      e.preventDefault();scrollToForm();
    }
  });
})();
